import React, { useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { FaRocket, FaTag, FaLayerGroup, FaChartLine } from 'react-icons/fa';

const AdminResourceForm = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [category, setCategory] = useState('');
  const [level, setLevel] = useState('beginner');
  const [tags, setTags] = useState('');
  const [image, setImage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('http://localhost:8000/api/resources', {
        title,
        content,
        category,
        level,
        tags: tags.split(',').map(tag => tag.trim())
      });
      alert('Resource added successfully!');
      // Clear the form
      setTitle('');
      setContent('');
      setCategory('');
      setLevel('beginner');
      setTags('');
    } catch (error) {
      alert('Failed to add resource');
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      transition={{ duration: 0.5 }}
      className="max-w-4xl mx-auto mt-10 p-8 bg-gray-900 rounded-lg shadow-lg"
    >
      <h2 className="text-3xl font-bold text-center text-blue-500 mb-8">Launch New Resource</h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        <motion.div whileHover={{ scale: 1.02 }} className="group">
          <label className="block text-blue-400 text-sm font-bold mb-2" htmlFor="title">
            <FaRocket className="inline mr-2" /> Mission Title
          </label>
          <input
            className="w-full px-3 py-2 text-gray-200 bg-gray-800 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
            id="title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </motion.div>

        <motion.div whileHover={{ scale: 1.02 }} className="group">
          <label className="block text-blue-400 text-sm font-bold mb-2" htmlFor="content">
            <FaLayerGroup className="inline mr-2" /> Mission Briefing
          </label>
          <textarea
            className="w-full px-3 py-2 text-gray-200 bg-gray-800 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
            id="content"
            rows="6"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            required
          />
        </motion.div>

        <div className="grid grid-cols-2 gap-4">
          <motion.div whileHover={{ scale: 1.02 }} className="group">
            <label className="block text-blue-400 text-sm font-bold mb-2" htmlFor="category">
              <FaTag className="inline mr-2" /> Galaxy Sector
            </label>
            <input
              className="w-full px-3 py-2 text-gray-200 bg-gray-800 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
              id="category"
              type="text"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              required
            />
          </motion.div>

          <motion.div whileHover={{ scale: 1.02 }} className="group">
            <label className="block text-blue-400 text-sm font-bold mb-2" htmlFor="level">
              <FaChartLine className="inline mr-2" /> Crew Expertise
            </label>
            <select
              className="w-full px-3 py-2 text-gray-200 bg-gray-800 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
              id="level"
              value={level}
              onChange={(e) => setLevel(e.target.value)}
            >
              <option value="beginner">Cadet</option>
              <option value="intermediate">Officer</option>
              <option value="advanced">Commander</option>
            </select>
          </motion.div>
        </div>

        <motion.div whileHover={{ scale: 1.02 }} className="group">
          <label className="block text-blue-400 text-sm font-bold mb-2" htmlFor="tags">
            <FaTag className="inline mr-2" /> Mission Tags (comma-separated)
          </label>
          <input
            className="w-full px-3 py-2 text-gray-200 bg-gray-800 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
            id="tags"
            type="text"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
          />
        </motion.div>

        <motion.div whileHover={{ scale: 1.02 }} className="group">
          <label className="block text-blue-400 text-sm font-bold mb-2" htmlFor="image">
            Mission Emblem
          </label>
          <input
            className="w-full px-3 py-2 text-gray-200 bg-gray-800 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
            id="image"
            type="file"
            onChange={(e) => setImage(e.target.files[0])}
            accept="image/*"
          />
        </motion.div>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out transform hover:-translate-y-1 hover:shadow-lg"
          type="submit"
        >
          Launch Resource <FaRocket className="inline ml-2" />
        </motion.button>
      </form>
    </motion.div>
  );
};

export default AdminResourceForm;